import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import SlideCarousel from '@r1-frontend/ui-react/components/SlideCarousel';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const MethodCarousel = styled(SlideCarousel)`
    margin-left: -4px;
`;

export const SaveCardBlock = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 12px;
`;

export const SaveCardInfo = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;

